module.exports = __webpack_public_path__ + "static/media/left_blob_web_trans1.426fcce3.png";